// extracted by mini-css-extract-plugin
export default {"addNewsBox":"courseAddOrEdit_addNewsBox__MU7HV","imgBox":"courseAddOrEdit_imgBox__0N29V","langTitle":"courseAddOrEdit_langTitle__r7bf5"};